<template>
  <div v-if="project" class="project">
    <div class="intro">
      <Hero
        partners="Marvin Bruns, Till Troll, Christopher Kötting, Patrick Schneider"
        project="»Siemens Home Appliances Award 2020« — Winner (First Place)"
        organisation="B/S/H Group & Fachhochschule Potsdam"
        heroBackground="https://images.prismic.io/felixdesignportfolio/eeb62ce9-ba68-47b8-83d0-11d3737add6d_background.png?auto=compress,format&rect=10,0,3330,2706"
        :heroLogo="project.data.preview[0].logo.url"
        heroType="Konzept"
        heroTitle="The Future delivered into home"
        :layout="project.data.position"
        :size="project.data.sizemodifier"
        :link="project.data.projectlink"
      ></Hero>
    </div>

    <!-- <section id="port-abstract">
      <HeadlineWithLine headline="Abstract" color="dark"></HeadlineWithLine>
      <div class="content flex-h2">
        <div>
          <img class="" src='/assets/img/projects/port-abstract-books.png'>
        </div>
        <div>
          <span class="textarea dark">
            <h1 class="dark">Was müssen wir noch besitzen? </h1>
            <p class="dark">Das Bedürfnis nach dem konkreten Besitz von Dingen, wie ein Regal voller Bücher, ist dank
              Streaming Anbietern, modernen Apps und Geräten stark zurück gegangen. </p>
            <p class="dark">Der Trend ist in den letzten Jahren auch in den Mobilitätssektor übergeschwappt, das eigene
              Auto wurde durch Carsharing sowie Fahrrad- und Roller-Verleih ersetzt.</p>
          </span>
        </div>
      </div>
    </section> -->

    <Scrollama :debug="false" :offset="1" @step-enter="stepEnterHandler" :progress="true" @step-progress="stepProgress">
      <div class="graphic" id="port-box-top" slot="graphic">
        <img class="scrollytell-image top" src='/assets/img/projects/port-boxes.png'>
        <img class="scrollytell-image top" id="fadeOut" src='/assets/img/projects/port-boxes-white.png'>
      </div>
      <div class="step left layout-right" id="step-1" data-step-no="1">
        <span class="textarea light">
          <h1>The future delivered— <br> straight into your home</h1>
          <p>Port is a concept for a future infrastructure. With port transporting items and goods through town is pretty much erased from above ground. Everything that fits in a 60cm × 40cm × 35cm large box can be delivered by port.</p>
          <p>Houses, flats and logistical centres are connected underground. That makes it possible to get anything you need in a matter of minutes.</p>
          <p>Apart from getting goods delivered, that could also mean trying on new shoes and sharing all kinds of things with friends an family.</p>
        </span>
      </div>
      <div class="step left layout-left" id="step-2" data-step-no="2">
        <span class="textarea light">
          <h1 class="light">All you need is a box—  <br></h1>
          <p>The core elements of port are the boxes integrated into its own ecosystem.
          </p>
          <p>Like a delivery van at the moment, these boxes are used and therefore restored into the cycle every day and adapt to the needs of the application.</p>
          <p>This opens up completely new possibilities for e-commerce. Additionally it relieves our infrastructure, which is not built for the goods traffic of our current time.</p>
        </span>
      </div>
    </Scrollama>

    <div class="box">
      <img src='/assets/img/projects/box-no-bg-top.png'>
    </div>

    <div class="section">
      <ArticleRenderer :project="project"></ArticleRenderer>
    </div>

    <div class="footer">
      <Footer></Footer>
    </div>

  </div>
</template>

<script>
  import 'intersection-observer' // for cross-browser support
  import Scrollama from 'vue-scrollama'
  import Hero from '@/components/Hero.vue'
  import HeadlineWithLine from '@/components/typography/HeadlineWithLine';
  import ArticleRenderer from '@/components/ArticleRenderer.vue'
  import Footer from '@/components/Footer.vue'

  import { mapState } from 'vuex'

  import Lottie from '@/lottie.vue';
  // import * as animationData from '../../assets/animations/ipad-animation.json';

  export default {
    components: {
      Scrollama,
      Hero,
      HeadlineWithLine,
      ArticleRenderer,
      Footer,
      'lottie': Lottie
    },
    data() {
      return {
        project: null,
        imageArray: [
          '/assets/img/projects/port-boxes.png'
        ],
         defaultOptions: {
            // animationData: animationData.default,
            loop: false,
            autoplay: false,
        },
        animationSpeed: 1,
        currStep: null,
        currStepProgress: null
      }
    },
    computed: {
      ...mapState([
        'projects'
      ])
    },
    watch: {
      projects: {
        handler: function() {
          if(this.projects.length > 0) {
            this.projects.forEach(element => {
              if(element.id == 'YD0I7RAAACIA1bsS') {
                this.project = element
              } else {
                console.log("Project could not be found in Projects Array — please check ID")
              }
            });
          }
        },
        immediate: true
      }
    },
    
    methods: {
      handleAnimation: function (anim) {
        this.anim = anim;
      },

      stepEnterHandler({
        element,
        index,
        direction
      }) {
        // handle the step-event as required here
        // console.log(element, index, direction)
      },
      stepProgress({
        element,
        index,
        progress
      }) {
        // console.log(element, index, progress)

        if (index == 0) {
          // console.log(progress);
          let opacity = this.map(progress, 0, 0.90, 1, 0);
          document.getElementById('fadeOut').style.opacity = opacity;
        }
      },
      videoProgress ({
        element,
        index,
        progress
      }) {
        // let duration = video.duration;
        let currentFrame = this.map(progress, 0.2, 1, 1, 135);


        if(currentFrame < 1) {
          currentFrame = 1;
        }

        this.anim.goToAndStop(currentFrame, true);
        this.zoom(progress);
      },

      zoom (progress) {
        let ipad = document.getElementById('ipad');

        let zoom;
        zoom = this.map(progress, 0, .2, 1, 2);

        if(zoom < 2) {
          ipad.style.transform = "scale(" + zoom + ")";
        }
      },

      map(value, x1, y1, x2, y2) {
        return (value - x1) * (y2 - x2) / (y1 - x1) + x2
      }
    }

  }
</script>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>

<style lang="scss" scoped>
  #step-1 {
    margin-bottom: 10vh;
  }

  #step-2 {
    transform: translateY(35vh);
    padding-top: 0;
    margin-bottom: 5rem;

    span {
      width: 60%;
    }
  }
</style>

<style lang="scss">
  @import '../../assets/scss/base.scss';

  intro,
  .outro {
    padding: 20vh;
  }

  .hero {
    max-width: 100vw;

    &>img {
      width: 100%;
    }
  }

  #port-box-top {
    background: #26353D;
  }

  #port-abstract {
    background: #D5DDDE;
  }

  #port-mega {
    background: rgb(20, 29, 35);
    background: linear-gradient(180deg, rgba(20, 29, 35, 1) 0%, rgba(6, 5, 6, 1) 100%);
  }

  .graphic {
    height: 100vh;
    background-color: #eee;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .scrollytell-image {
    position: absolute;
    object-fit: contain;

    &.top {
      z-index: 10;
    }

    @include lg() {
      width: 150% !important;
      left: 0
    }
  }

  .step {
    padding: 15vh 0;
    width: 50%;
    margin: 0 auto 30vh;
    display: flex;
  }

  .box {
    img {
      position: relative;
      bottom: 0;
      width: 100%;
      max-width: inherit;
    }
  }

  .video {
    width: 1280px;
    border-radius: 4px;
    background: $port-background;
  }

  .ipad {
    position: relative;
    .ipad-device {
      z-index: 10;
    }
    .ipad-frontend {
      width: 25% !important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-60%);
      z-index: -1;
    }
  }

  
</style>